import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import AlterarClienteProcesso from './AlterarClienteProcesso';

function AlterarClienteProcessoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Alterar Cliente Processo'));
  return (
    <AlterarClienteProcesso />
  );
}

export default withTokenInterceptor(AlterarClienteProcessoPage);
